import React, { Component } from "react";
import { Field, TextInput } from "@streeteasy/design-system";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import { func, string } from "prop-types";

import querySuggestedEmail from "./querySuggestedEmail";
import {
  QuestionMarkWrapper,
  SuggestedEmailContainer,
  SuggestedEmailText
} from "./styled";

class SmartEmailField extends Component {
  state = { suggestedValue: "" };

  emailRegex = /\S+@\S+\.\S+/i; // True for any email that follows the text + @ + sometext + .something pattern

  clearSuggestedValue = () => this.setState({ suggestedValue: "" });

  handleClick = () => {
    this.props.handleSuggestedEmailClick(this.state.suggestedValue);
    this.clearSuggestedValue();
  };

  isValidEmail = testString => this.emailRegex.test(testString);

  localHandleChange = event => {
    if (this.state.suggestedValue) {
      this.clearSuggestedValue(); // Clear value so suggestion doesn't stick after user types correct email themselves
    }

    if (this.isValidEmail(event.target.value)) {
      const suggestedValue = querySuggestedEmail(event.target.value);

      if (suggestedValue) {
        this.setState({ suggestedValue });
      }
    }

    this.props.handleInputChange(event.target.value, event);
  };

  render() {
    return (
      <>
        <Field
          id="login-email-input"
          isValid={!this.props.isInvalid}
          label="Email"
        >
          <TextInput
            aria-describedby="err-msg"
            autocomplete="email"
            autoFocus
            name="email"
            onChange={this.localHandleChange}
            type="email"
            value={this.props.value}
          />
        </Field>
        <SuggestedEmailContainer isVisible={this.state.suggestedValue}>
          <SuggestedEmailText>
            Did you mean&nbsp;
            {this.state.suggestedValue.length > 27 ? <br /> : null}
            <TextLink
              href="#"
              onClick={this.handleClick}
              theme="primaryTouched"
            >
              {this.state.suggestedValue}
            </TextLink>
            <QuestionMarkWrapper>?</QuestionMarkWrapper>
          </SuggestedEmailText>
        </SuggestedEmailContainer>
      </>
    );
  }
}

SmartEmailField.propTypes = {
  handleInputChange: func.isRequired,
  handleSuggestedEmailClick: func.isRequired,
  isInvalid: string,
  value: string.isRequired
};

SmartEmailField.defaultProps = {
  isInvalid: ""
};

export default SmartEmailField;
